import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';

export const StyledProjectInput = styled('div')`
  display: ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled ? 'flex' : 'grid'};
  ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled
      ? 'flex-wrap: wrap;'
      : 'grid-template-columns: repeat(auto-fit, minmax(150px, 200px));'}
  width: 100%;
  max-width: 2000px;
  gap: 24px;
  margin-bottom: 8px;
  margin-top: ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled ? '24px' : '8px'};
`;

export const StyledProjectInputItem = styled('div')`
  cursor: ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled ? 'default' : 'pointer'};
  height: ${({ newUiProjectsEnabled }) => !newUiProjectsEnabled && '148px'};
  width: ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled ? 'auto' : '100%'};
  display: flex;
  justify-content: center;
  align-items: ${({ newUiProjectsEnabled }) =>
    newUiProjectsEnabled ? 'flex-start' : 'center'};
  flex-direction: column;

  &:hover {
    .img-wrapper {
      background-color: ${({ newUiProjectsEnabled }) =>
        newUiProjectsEnabled ? 'transparent' : TRANSPARENT_COLOR.dark};
      box-shadow: ${({ newUiProjectsEnabled }) =>
        newUiProjectsEnabled ? 'none' : '0 0 10px 0 rgba(0, 0, 0, 0.1)'};

      .img-item {
        box-shadow: ${({ newUiProjectsEnabled }) =>
          newUiProjectsEnabled
            ? '0px 4px 16px 0px rgba(0, 0, 0, 0.08)'
            : 'none'};
      }

      .img-item::after {
        opacity: 1;
      }

      .img-item .btn-plus {
        opacity: 1;
      }
    }
  }

  .img-wrapper {
    background-color: ${({ newUiProjectsEnabled }) =>
      newUiProjectsEnabled ? 'transparent' : COLOR.background};
    border-radius: 16px;
    width: ${({ newUiProjectsEnabled }) =>
      newUiProjectsEnabled ? '200px' : '100%'};
    height: 100%;
    margin-bottom: 8px;
    display: flex;
    justify-content: ${({ newUiProjectsEnabled }) =>
      newUiProjectsEnabled ? 'flex-start' : 'center'};
    align-items: center;
    height: 120px;
    transition: box-shadow 0.15s ease;

    .img-item {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      transition: box-shadow 0.15s ease;
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(255, 255, 255, 0.16);
        backdrop-filter: blur(4px);
        border-radius: 16px;
        opacity: ${({ isTooltipOpen }) => (isTooltipOpen ? 1 : 0)};
        transition: opacity 0.1s ease;
      }

      .btn-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        opacity: ${({ isTooltipOpen }) => (isTooltipOpen ? 1 : 0)};
        transition: opacity 0.1s ease;
        border-radius: 8px;
        background-color: ${COLOR.darkBlue};
        height: 40px;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .title-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    .card-title {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      letter-spacing: -0.4px;
      color: #000000;
    }
  }
`;

export const StyledOptionCreateProject = styled('div')`
  background-color: ${COLOR.white};
  border-radius: 8px;
  padding: 8px;
  width: 224px;
`;

export const StyledItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  padding: 8px;
  box-sizing: border-box;
  &:hover {
    background-color: ${COLOR.backgroundRecordTime};
  }
`;
